module.exports = __webpack_public_path__ + "static/media/devika.039c9485.webp";